import React, { useEffect, useRef } from 'react';
import grapesjs from 'grapesjs';
import 'grapesjs/dist/css/grapes.min.css';
import grapesjsPresetWebpage from 'grapesjs-preset-webpage';
import grapesjsCkeditor from 'grapesjs-plugin-ckeditor';

const DevScreen = (props) => {
  const editorRef = useRef(null);
  const editorInstanceRef = useRef(null);

  useEffect(() => {
    if (editorInstanceRef.current) return;

    editorInstanceRef.current = grapesjs.init({
      container: editorRef.current,
      height: 'calc(100vh - 64px)',
      width: '100%',
      plugins: [grapesjsPresetWebpage, grapesjsCkeditor],
      pluginsOpts: {
        [grapesjsPresetWebpage]: {},
        [grapesjsCkeditor]: {
          ckeditor: 'https://cdn.ckeditor.com/4.25.1-lts/standard-all/ckeditor.js',
          position: 'center',
          options: {
            startupFocus: true,
            extraAllowedContent: '*(*);*{*}',
            allowedContent: true,
            enterMode: 2, // CKEDITOR.ENTER_BR
            extraPlugins: 'sharedspace,justify,colorbutton,panelbutton,font',
            toolbar: [
              { name: 'styles', items: ['Font', 'FontSize'] },
              ['Bold', 'Italic', 'Underline', 'Strike'],
              { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
              { name: 'colors', items: ['TextColor', 'BGColor'] },
              { name: 'links', items: ['Link', 'Unlink'] },
            ],
          },
        },
      },
      storageManager: false,
      keymaps: {
        defaults: {
          'core:preview': {
            keys: 'ctrl+shift+p',
            handler: 'core:preview',
          },
        },
      },
    });

    // Escape key exits preview mode
    const editor = editorInstanceRef.current;
    const exitPreview = (e) => {
      if (e.key === 'Escape') {
        editor.stopCommand('preview');
        editor.stopCommand('core:preview');
      }
    };
    document.addEventListener('keydown', exitPreview);

    // Also listen inside the canvas iframe
    editor.on('load', () => {
      const iframeDoc = editor.Canvas.getDocument();
      if (iframeDoc) {
        iframeDoc.addEventListener('keydown', exitPreview);
      }
    });

    return () => {
      document.removeEventListener('keydown', exitPreview);
      if (editorInstanceRef.current) {
        editorInstanceRef.current.destroy();
        editorInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <div className={props.screenWidth < 600 ? 'not_expanded' : 'expanded'} style={{ height: 'calc(100vh - 84px)', position: 'relative', overflow: 'hidden' }}>
      <style>{`
        .gjs-editor-cont { position: absolute !important; top: 0; left: 10px; right: 0; bottom: 0; width: auto !important; height: auto !important; }
        .gjs-editor { position: absolute !important; top: 0; left: 0; right: 0; bottom: 0; }
      `}</style>
      <div ref={editorRef} style={{ height: '100%', width: '100%' }} />
    </div>
  );
};

export default DevScreen;
